import { AppGame } from "@core-types/game.enum";
import type { IRegionStrategy } from "./IRegionStrategy";
import { LolRegionStrategy } from "./strategies/LolRegionStrategy";
import { ValorantRegionStrategy } from "./strategies/ValorantRegionStrategy";

export class RegionStrategyFactory {
  private static strategies: Record<AppGame, IRegionStrategy> = {
    [AppGame.LOL]: new LolRegionStrategy(),
    [AppGame.VALORANT]: new ValorantRegionStrategy(),
  };

  static getStrategy(game: AppGame): IRegionStrategy {
    return (
      RegionStrategyFactory.strategies[game] ||
      RegionStrategyFactory.strategies[AppGame.LOL]
    );
  }
}
